import gql from 'graphql-tag'

import { ExternalSchoolFieldsFragment } from 'main/gql/externalSchool'

export const EXTERNAL_SCHOOL_MAP_CALLOUT_QUERY = gql`
  query ExternalSchoolMapCallout($externalSchoolId: Int!) {
    externalSchool(id: $externalSchoolId) {
      ...ExternalSchoolFields
    }
  }

  ${ExternalSchoolFieldsFragment}
`
